import { supabase } from '@/integrations/supabase/client';
import type { PrerenderedAvatar } from '@/lib/prerenderedAvatars';

/** The existing database trigger swaps active rows in the SAME transaction.
 * Never demote separately: a rejected insert would strand the old avatar.
 * Reusing an owned catalog row also avoids duplicates and the insert throttle.
 */
export async function selectCatalogAvatar(userId: string, avatar: PrerenderedAvatar): Promise<void> {
  const { data: existing, error: lookupError } = await supabase.from('user_avatars')
    .select('id, is_active').eq('user_id', userId).eq('avatar_url', avatar.glbUrl)
    .order('is_active', { ascending: false }).order('created_at', { ascending: false })
    .limit(1).maybeSingle();
  if (lookupError) throw lookupError;
  if (existing?.is_active) return;
  if (existing) {
    const { data: saved, error } = await supabase.from('user_avatars').update({ is_active: true })
      .eq('user_id', userId).eq('id', existing.id).select('id').maybeSingle();
    if (error) throw error;
    if (!saved) throw new Error('Avatar activation was not confirmed');
    return;
  }
  const { error } = await supabase.from('user_avatars').insert({
    user_id: userId, avatar_url: avatar.glbUrl, provider: 'metaperson',
    is_active: true, label: `prerendered:${avatar.id}`,
  });
  if (error) throw error;
}
